import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, Subject, throwError } from 'rxjs';
import { UserType } from '../enums/constants';
import { LegalFinancialContactSaveEvent } from '../interfaces/legalFinancialContactSaveEvent';
import { ResponseInterface } from '../interfaces/response';
import { UserService } from './user.service';

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  user: any;
  allContacts: any[] = [];
  designeeControl: any[] = [];
  contactsRoleNone: any[] = [];
  legalFinancialContacts: any[] = [];
  banks: any[] = [];
  wills: any[] = [];
  additionalDocs: any[] = [];
  realEstates: any[] = [];
  loginAccounts: any[] = [];
  trusts: any[] = [];
  insurances: any[] = [];
  privateInvestments: any[] = [];
  multimedias: any[] = [];
  retirementAccounts: any[] = [];
  taxAccountants: any[] = [];
  taxReturn: any[] = [];
  taxBasis: any[] = [];
  identification: any[] = [];
  taxDocumentation: any[] = [];
  legalFinancialContactSaveAction: Subject<LegalFinancialContactSaveEvent>;
  legalFinancialContactSaveEvents$: Observable<LegalFinancialContactSaveEvent>;

  cardsMinimumData = {
    banks: [],
    realEstates: [],
    loginAccounts: [],
    trusts: [],
    insurances: [],
    privateInvestments: [],
    multimedias: [],
    additionalDocs: [],
    wills: [],
    retirementAccounts: [],
    taxAccountants: [],
    taxReturn: [],
    taxDocumentation: [],
    taxBasis: [],
    identification: [],
  };

  private syncDataAction: Subject<boolean>;
  syncDataEvents$: Observable<boolean>;

  constructor(
    private http: HttpClient,
    private router: Router,
    private userService: UserService
  ) {
    this.legalFinancialContactSaveAction =
      new Subject<LegalFinancialContactSaveEvent>();
    this.legalFinancialContactSaveEvents$ =
      this.legalFinancialContactSaveAction.asObservable();
    this.syncDataAction = new Subject();
    this.syncDataEvents$ = this.syncDataAction.asObservable();
  }

  handleError(error: HttpErrorResponse) {
    console.log(error);
    if (this.router) {
      //this.router.navigate(['/login']);
    }

    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      console.error(
        `Backend returned code ${error.status}, ` + `body was: ${error.error}`
      );
    }
    //window.location.href = "/login";
    // return an observable with a user-facing error message
    return throwError('please try again later.');
  }

  getWills(reqparams, responseInterface: ResponseInterface<any>) {
    return this.http.post<any>('/api/will/search', reqparams).subscribe(
      (res: any) => {
        responseInterface.getResult(res);
      },
      (err) => {
        responseInterface.getError(err);
      }
    );
  }
  addWill(reqparams, responseInterface: ResponseInterface<any>) {
    return this.http.post<any>('/api/will/add', reqparams).subscribe(
      (res: any) => {
        responseInterface.getResult(res);
      },
      (err) => {
        responseInterface.getError(err);
      }
    );
  }
  editWill(reqparams, responseInterface: ResponseInterface<any>) {
    return this.http.post<any>('/api/will/edit', reqparams).subscribe(
      (res: any) => {
        responseInterface.getResult(res);
      },
      (err) => {
        responseInterface.getError(err);
      }
    );
  }
  deleteWill(reqparams, responseInterface: ResponseInterface<any>) {
    return this.http.post<any>('/api/will/delete', reqparams).subscribe(
      (res: any) => {
        responseInterface.getResult(res);
      },
      (err) => {
        responseInterface.getError(err);
      }
    );
  }

  getAccountDevices(reqparams, responseInterface: ResponseInterface<any>) {
    return this.http
      .post<any>('/api/account-device/search', reqparams)
      .subscribe(
        (res: any) => {
          responseInterface.getResult(res);
        },
        (err) => {
          responseInterface.getError(err);
        }
      );
  }
  addAccountDevice(reqparams, responseInterface: ResponseInterface<any>) {
    return this.http.post<any>('/api/account-device/add', reqparams).subscribe(
      (res: any) => {
        responseInterface.getResult(res);
      },
      (err) => {
        responseInterface.getError(err);
      }
    );
  }
  editAccountDevice(reqparams, responseInterface: ResponseInterface<any>) {
    return this.http.post<any>('/api/account-device/edit', reqparams).subscribe(
      (res: any) => {
        responseInterface.getResult(res);
      },
      (err) => {
        responseInterface.getError(err);
      }
    );
  }
  deleteAccountDevice(reqparams, responseInterface: ResponseInterface<any>) {
    return this.http
      .post<any>('/api/account-device/delete', reqparams)
      .subscribe(
        (res: any) => {
          responseInterface.getResult(res);
        },
        (err) => {
          responseInterface.getError(err);
        }
      );
  }

  getBankAccounts(reqparams, responseInterface: ResponseInterface<any>) {
    return this.http.post<any>('/api/bank-account/search', reqparams).subscribe(
      (res: any) => {
        responseInterface.getResult(res);
      },
      (err) => {
        responseInterface.getError(err);
      }
    );
  }
  addBankAccount(reqparams, responseInterface: ResponseInterface<any>) {
    return this.http.post<any>('/api/bank-account/add', reqparams).subscribe(
      (res: any) => {
        responseInterface.getResult(res);
      },
      (err) => {
        responseInterface.getError(err);
      }
    );
  }
  editBankAccount(reqparams, responseInterface: ResponseInterface<any>) {
    return this.http.post<any>('/api/bank-account/edit', reqparams).subscribe(
      (res: any) => {
        responseInterface.getResult(res);
      },
      (err) => {
        responseInterface.getError(err);
      }
    );
  }
  deleteBankAccount(reqparams, responseInterface: ResponseInterface<any>) {
    return this.http.post<any>('/api/bank-account/delete', reqparams).subscribe(
      (res: any) => {
        responseInterface.getResult(res);
      },
      (err) => {
        responseInterface.getError(err);
      }
    );
  }

  getInsurances(reqparams, responseInterface: ResponseInterface<any>) {
    return this.http.post<any>('/api/insurance/search', reqparams).subscribe(
      (res: any) => {
        responseInterface.getResult(res);
      },
      (err) => {
        responseInterface.getError(err);
      }
    );
  }

  addInsurance(reqparams, responseInterface: ResponseInterface<any>) {
    return this.http.post<any>('/api/insurance/add', reqparams).subscribe(
      (res: any) => {
        responseInterface.getResult(res);
      },
      (err) => {
        responseInterface.getError(err);
      }
    );
  }

  editInsurance(reqparams, responseInterface: ResponseInterface<any>) {
    return this.http.post<any>('/api/insurance/edit', reqparams).subscribe(
      (res: any) => {
        responseInterface.getResult(res);
      },
      (err) => {
        responseInterface.getError(err);
      }
    );
  }
  deleteInsurance(reqparams, responseInterface: ResponseInterface<any>) {
    return this.http.post<any>('/api/insurance/delete', reqparams).subscribe(
      (res: any) => {
        responseInterface.getResult(res);
      },
      (err) => {
        responseInterface.getError(err);
      }
    );
  }

  getPrivateInvestments(reqparams, responseInterface: ResponseInterface<any>) {
    return this.http
      .post<any>('/api/private-investment/search', reqparams)
      .subscribe(
        (res: any) => {
          responseInterface.getResult(res);
        },
        (err) => {
          responseInterface.getError(err);
        }
      );
  }

  addPrivateInvestment(reqparams, responseInterface: ResponseInterface<any>) {
    return this.http
      .post<any>('/api/private-investment/add', reqparams)
      .subscribe(
        (res: any) => {
          responseInterface.getResult(res);
        },
        (err) => {
          responseInterface.getError(err);
        }
      );
  }

  editPrivateInvestment(reqparams, responseInterface: ResponseInterface<any>) {
    return this.http
      .post<any>('/api/private-investment/edit', reqparams)
      .subscribe(
        (res: any) => {
          responseInterface.getResult(res);
        },
        (err) => {
          responseInterface.getError(err);
        }
      );
  }
  deletePrivateInvestment(
    reqparams,
    responseInterface: ResponseInterface<any>
  ) {
    return this.http
      .post<any>('/api/private-investment/delete', reqparams)
      .subscribe(
        (res: any) => {
          responseInterface.getResult(res);
        },
        (err) => {
          responseInterface.getError(err);
        }
      );
  }

  getTrusts(reqparams, responseInterface: ResponseInterface<any>) {
    return this.http.post<any>('/api/trust/search', reqparams).subscribe(
      (res: any) => {
        responseInterface.getResult(res);
      },
      (err) => {
        responseInterface.getError(err);
      }
    );
  }

  addTrust(reqparams, responseInterface: ResponseInterface<any>) {
    return this.http.post<any>('/api/trust/add', reqparams).subscribe(
      (res: any) => {
        responseInterface.getResult(res);
      },
      (err) => {
        responseInterface.getError(err);
      }
    );
  }
  editTrust(reqparams, responseInterface: ResponseInterface<any>) {
    return this.http.post<any>('/api/trust/edit', reqparams).subscribe(
      (res: any) => {
        responseInterface.getResult(res);
      },
      (err) => {
        responseInterface.getError(err);
      }
    );
  }
  deleteTrust(reqparams, responseInterface: ResponseInterface<any>) {
    return this.http.post<any>('/api/trust/delete', reqparams).subscribe(
      (res: any) => {
        responseInterface.getResult(res);
      },
      (err) => {
        responseInterface.getError(err);
      }
    );
  }

  getRealEstate(reqparams, responseInterface: ResponseInterface<any>) {
    return this.http.post<any>('/api/real-estate/search', reqparams).subscribe(
      (res: any) => {
        responseInterface.getResult(res);
      },
      (err) => {
        responseInterface.getError(err);
      }
    );
  }
  addRealEstate(reqparams, responseInterface: ResponseInterface<any>) {
    return this.http.post<any>('/api/real-estate/add', reqparams).subscribe(
      (res: any) => {
        responseInterface.getResult(res);
      },
      (err) => {
        responseInterface.getError(err);
      }
    );
  }
  editRealEstate(reqparams, responseInterface: ResponseInterface<any>) {
    return this.http.post<any>('/api/real-estate/edit', reqparams).subscribe(
      (res: any) => {
        responseInterface.getResult(res);
      },
      (err) => {
        responseInterface.getError(err);
      }
    );
  }
  deleteRealEstate(reqparams, responseInterface: ResponseInterface<any>) {
    return this.http.post<any>('/api/real-estate/delete', reqparams).subscribe(
      (res: any) => {
        responseInterface.getResult(res);
      },
      (err) => {
        responseInterface.getError(err);
      }
    );
  }

  getContacts(reqparams, responseInterface: ResponseInterface<any>) {
    const route =
      this.userService.user.usertype === UserType.ADMIN
        ? '/api/admin/user/contact'
        : '/api/contacts/search';

    return this.http.post<any>(route, reqparams).subscribe(
      (res: any) => {
        responseInterface.getResult(res);
      },
      (err) => {
        responseInterface.getError(err);
      }
    );
  }
  addContact(reqparams, userId, responseInterface: ResponseInterface<any>) {
    const route =
      this.userService.user.usertype === UserType.ADMIN
        ? `/api/admin/contact/add/${userId}`
        : '/api/contact/add';
    return this.http.post<any>(route, reqparams).subscribe(
      (res: any) => {
        responseInterface.getResult(res);
      },
      (err) => {
        responseInterface.getError(err);
      }
    );
  }
  addContactSpouse(
    reqparams,
    userId,
    responseInterface: ResponseInterface<any>
  ) {
    const route =
      this.userService.user.usertype === UserType.ADMIN
        ? `/api/admin/contact/add/spouse/${userId}`
        : '/api/contact/add/spouse';
    return this.http.post<any>(route, reqparams).subscribe(
      (res: any) => {
        responseInterface.getResult(res);
      },
      (err) => {
        responseInterface.getError(err);
      }
    );
  }
  editContact(reqparams, userId, responseInterface: ResponseInterface<any>) {
    const route =
      this.userService.user.usertype === UserType.ADMIN
        ? `/api/admin/contact/edit/${userId}`
        : '/api/contact/edit';
    return this.http.post<any>(route, reqparams).subscribe(
      (res: any) => {
        responseInterface.getResult(res);
      },
      (err) => {
        responseInterface.getError(err);
      }
    );
  }
  deleteContact(reqparams, userId, responseInterface: ResponseInterface<any>) {
    const route =
      this.userService.user.usertype === UserType.ADMIN
        ? `/api/admin/contact/delete/${userId}`
        : '/api/contact/delete';
    return this.http.post<any>(route, reqparams).subscribe(
      (res: any) => {
        responseInterface.getResult(res);
      },
      (err) => {
        responseInterface.getError(err);
      }
    );
  }

  deleteContactSpouse(
    reqparams,
    userId,
    responseInterface: ResponseInterface<any>
  ) {
    const route =
      this.userService.user.usertype === UserType.ADMIN
        ? `/api/admin/contact/delete/spouse/${userId}`
        : '/api/contact/delete/spouse';
    return this.http.post<any>(route, reqparams).subscribe(
      (res: any) => {
        responseInterface.getResult(res);
      },
      (err) => {
        responseInterface.getError(err);
      }
    );
  }
  deleteNoneTypeContact(
    reqparams,
    userId,
    responseInterface: ResponseInterface<any>
  ) {
    const route =
      this.userService.user.usertype === UserType.ADMIN
        ? `/api/admin/contact/delete/none-typed/${userId}`
        : '/api/contact/delete/none-typed';
    return this.http.post<any>(route, reqparams).subscribe(
      (res: any) => {
        responseInterface.getResult(res);
      },
      (err) => {
        responseInterface.getError(err);
      }
    );
  }

  resendContactInvitation(
    reqParams,
    userId,
    responseInterface: ResponseInterface<any>
  ) {
    const route =
      this.userService.user.usertype === UserType.ADMIN
        ? `/api/admin/resend-contact-invitation/${userId}`
        : '/api/user/resend-contact-invitation';
    return this.http.post<any>(route, reqParams).subscribe(
      (res: any) => {
        responseInterface.getResult(res);
      },
      (err) => {
        responseInterface.getError(err);
      }
    );
  }

  getLegalFinancialContacts(
    reqparams,
    responseInterface: ResponseInterface<any>
  ) {
    return this.http
      .post<any>('/api/legal-financial-contact/search', reqparams)
      .subscribe(
        (res: any) => {
          responseInterface.getResult(res);
        },
        (err) => {
          responseInterface.getError(err);
        }
      );
  }
  addLegalFinancialContact(
    reqparams,
    responseInterface: ResponseInterface<any>
  ) {
    return this.http
      .post<any>('/api/legal-financial-contact/add', reqparams)
      .subscribe(
        (res: any) => {
          responseInterface.getResult(res);
        },
        (err) => {
          responseInterface.getError(err);
        }
      );
  }
  editLegalFinancialContact(
    reqparams,
    responseInterface: ResponseInterface<any>
  ) {
    return this.http
      .post<any>('/api/legal-financial-contact/edit', reqparams)
      .subscribe(
        (res: any) => {
          responseInterface.getResult(res);
        },
        (err) => {
          responseInterface.getError(err);
        }
      );
  }
  deleteLegalFinancialContact(
    reqparams,
    responseInterface: ResponseInterface<any>
  ) {
    return this.http
      .post<any>('/api/legal-financial-contact/delete', reqparams)
      .subscribe(
        (res: any) => {
          responseInterface.getResult(res);
        },
        (err) => {
          responseInterface.getError(err);
        }
      );
  }

  deleteFile(reqparams, responseInterface: ResponseInterface<any>) {
    return this.http.post<any>('/api/file/delete', reqparams).subscribe(
      (res: any) => {
        responseInterface.getResult(res);
      },
      (err) => {
        responseInterface.getError(err);
      }
    );
  }

  deleteUploadFailedFile(reqparams, responseInterface: ResponseInterface<any>) {
    return this.http
      .post<any>('/api/file/delete-upload-failed-file', reqparams)
      .subscribe(
        (res: any) => {
          responseInterface.getResult(res);
        },
        (err) => {
          responseInterface.getError(err);
        }
      );
  }

  getFileStatuses(reqparams, responseInterface: ResponseInterface<any>) {
    return this.http.post<any>('/api/file/statuses', reqparams).subscribe(
      (res: any) => {
        responseInterface.getResult(res);
      },
      (err) => {
        responseInterface.getError(err);
      }
    );
  }

  getAdditionalDocs(reqparams, responseInterface: ResponseInterface<any>) {
    return this.http
      .post<any>('/api/additional-docs/search', reqparams)
      .subscribe(
        (res: any) => {
          responseInterface.getResult(res);
        },
        (err) => {
          responseInterface.getError(err);
        }
      );
  }
  addAdditionalDocs(reqparams, responseInterface: ResponseInterface<any>) {
    return this.http.post<any>('/api/additional-docs/add', reqparams).subscribe(
      (res: any) => {
        responseInterface.getResult(res);
      },
      (err) => {
        responseInterface.getError(err);
      }
    );
  }
  editAdditionalDocs(reqparams, responseInterface: ResponseInterface<any>) {
    return this.http
      .post<any>('/api/additional-docs/edit', reqparams)
      .subscribe(
        (res: any) => {
          responseInterface.getResult(res);
        },
        (err) => {
          responseInterface.getError(err);
        }
      );
  }
  deleteAdditionalDocs(reqparams, responseInterface: ResponseInterface<any>) {
    return this.http
      .post<any>('/api/additional-docs/delete', reqparams)
      .subscribe(
        (res: any) => {
          responseInterface.getResult(res);
        },
        (err) => {
          responseInterface.getError(err);
        }
      );
  }

  getMultimedia(reqparams, responseInterface: ResponseInterface<any>) {
    return this.http.post<any>('/api/multimedia/search', reqparams).subscribe(
      (res: any) => {
        responseInterface.getResult(res);
      },
      (err) => {
        responseInterface.getError(err);
      }
    );
  }
  addMultimedia(reqparams, responseInterface: ResponseInterface<any>) {
    return this.http.post<any>('/api/multimedia/add', reqparams).subscribe(
      (res: any) => {
        responseInterface.getResult(res);
      },
      (err) => {
        responseInterface.getError(err);
      }
    );
  }
  editMultimedia(reqparams, responseInterface: ResponseInterface<any>) {
    return this.http.post<any>('/api/multimedia/edit', reqparams).subscribe(
      (res: any) => {
        responseInterface.getResult(res);
      },
      (err) => {
        responseInterface.getError(err);
      }
    );
  }
  deleteMultimedia(reqparams, responseInterface: ResponseInterface<any>) {
    return this.http.post<any>('/api/multimedia/delete', reqparams).subscribe(
      (res: any) => {
        responseInterface.getResult(res);
      },
      (err) => {
        responseInterface.getError(err);
      }
    );
  }

  generateCheckoutLink(reqparams): Observable<any> {
    return this.http.post<any>('/api/generate-checkout-link', reqparams);
  }

  getSubscriptionDetails(params, responseInterface: ResponseInterface<any>) {
    return this.http.post<any>('/api/subscription', params).subscribe(
      (res: any) => {
        responseInterface.getResult(res);
      },
      (err) => {
        responseInterface.getError(err);
      }
    );
  }

  agreeTerms(params, responseInterface: ResponseInterface<any>) {
    return this.http.post<any>('/api/terms/agree', params).subscribe(
      (res: any) => {
        responseInterface.getResult(res);
      },
      (err) => {
        responseInterface.getError(err);
      }
    );
  }

  getTerms(params, responseInterface: ResponseInterface<any>) {
    return this.http.post<any>('/api/terms/get', params).subscribe(
      (res: any) => {
        responseInterface.getResult(res);
      },
      (err) => {
        responseInterface.getError(err);
      }
    );
  }

  getNavbarInfo(reqparams, responseInterface: ResponseInterface<any>) {
    return this.http.post<any>('/api/navbar/info', reqparams).subscribe(
      (res: any) => {
        responseInterface.getResult(res);
      },
      (err) => {
        responseInterface.getError(err);
      }
    );
  }

  addContactUsForm(params, responseInterface: ResponseInterface<any>) {
    return this.http.post<any>('/api/contactus/add', params).subscribe(
      (res: any) => {
        responseInterface.getResult(res);
      },
      (err) => {
        responseInterface.getError(err);
      }
    );
  }

  getFAQ(params, responseInterface: ResponseInterface<any>) {
    return this.http.post<any>('/api/faq/get', params).subscribe(
      (res: any) => {
        responseInterface.getResult(res);
      },
      (err) => {
        responseInterface.getError(err);
      }
    );
  }

  getFinancialAssets(reqparams, responseInterface: ResponseInterface<any>) {
    return this.http
      .post<any>('/api/financial-assets/search', reqparams)
      .subscribe(
        (res: any) => {
          responseInterface.getResult(res);
        },
        (err) => {
          responseInterface.getError(err);
        }
      );
  }
  addFinancialAsset(reqparams, responseInterface: ResponseInterface<any>) {
    return this.http
      .post<any>('/api/financial-assets/add', reqparams)
      .subscribe(
        (res: any) => {
          responseInterface.getResult(res);
        },
        (err) => {
          responseInterface.getError(err);
        }
      );
  }
  editFinancialAsset(reqparams, responseInterface: ResponseInterface<any>) {
    return this.http
      .post<any>('/api/financial-assets/edit', reqparams)
      .subscribe(
        (res: any) => {
          responseInterface.getResult(res);
        },
        (err) => {
          responseInterface.getError(err);
        }
      );
  }
  deleteFinancialAsset(reqparams, responseInterface: ResponseInterface<any>) {
    return this.http
      .post<any>('/api/financial-assets/delete', reqparams)
      .subscribe(
        (res: any) => {
          responseInterface.getResult(res);
        },
        (err) => {
          responseInterface.getError(err);
        }
      );
  }

  getPolicies(reqparams, responseInterface: ResponseInterface<any>) {
    return this.http.post<any>('/api/policy/search', reqparams).subscribe(
      (res: any) => {
        responseInterface.getResult(res);
      },
      (err) => {
        responseInterface.getError(err);
      }
    );
  }
  addPolicy(reqparams, responseInterface: ResponseInterface<any>) {
    return this.http.post<any>('/api/policy/add', reqparams).subscribe(
      (res: any) => {
        responseInterface.getResult(res);
      },
      (err) => {
        responseInterface.getError(err);
      }
    );
  }
  editPolicy(reqparams, responseInterface: ResponseInterface<any>) {
    return this.http.post<any>('/api/policy/edit', reqparams).subscribe(
      (res: any) => {
        responseInterface.getResult(res);
      },
      (err) => {
        responseInterface.getError(err);
      }
    );
  }
  deletePolicy(reqparams, responseInterface: ResponseInterface<any>) {
    return this.http.post<any>('/api/policy/delete', reqparams).subscribe(
      (res: any) => {
        responseInterface.getResult(res);
      },
      (err) => {
        responseInterface.getError(err);
      }
    );
  }

  getSubscriptionPlansForUser(
    reqparams,
    responseInterface: ResponseInterface<any>
  ) {
    return this.http
      .post<any>('/api/subscription-plan/search', reqparams)
      .subscribe(
        (res: any) => {
          responseInterface.getResult(res);
        },
        (err) => {
          responseInterface.getError(err);
        }
      );
  }

  updateUserSubscription(
    params,
    userId,
    responseInterface: ResponseInterface<any>
  ) {
    return this.http
      .post<any>(`/api/admin/edit-user-subscription/${userId}`, params)
      .subscribe(
        (res: any) => {
          responseInterface.getResult(res);
        },
        (err) => {
          responseInterface.getError(err);
        }
      );
  }

  getSubscriptionPlansForAdmin(
    userId,
    responseInterface: ResponseInterface<any>
  ) {
    return this.http
      .post<any>(`/api/admin/subscription-plan/search/${userId}`, {})
      .subscribe(
        (res: any) => {
          responseInterface.getResult(res);
        },
        (err) => {
          responseInterface.getError(err);
        }
      );
  }

  getSubscriptionPlanById(
    reqparams,
    responseInterface: ResponseInterface<any>
  ) {
    return this.http
      .post<any>('/api/subscription-plan/get', reqparams)
      .subscribe(
        (res: any) => {
          responseInterface.getResult(res);
        },
        (err) => {
          responseInterface.getError(err);
        }
      );
  }

  getSubscriptionCredit(reqparams, responseInterface: ResponseInterface<any>) {
    return this.http
      .post<any>(
        '/api/subscription-plan/get-discount-and-start-date',
        reqparams
      )
      .subscribe(
        (res: any) => {
          responseInterface.getResult(res);
        },
        (err) => {
          responseInterface.getError(err);
        }
      );
  }

  cancelNextSubscription(reqparams, responseInterface: ResponseInterface<any>) {
    return this.http
      .post<any>('/api/subscription-plan/cancel-next', reqparams)
      .subscribe(
        (res: any) => {
          responseInterface.getResult(res);
        },
        (err) => {
          responseInterface.getError(err);
        }
      );
  }

  getSubscriptionCustomerLink(
    reqparams,
    responseInterface: ResponseInterface<any>
  ) {
    return this.http
      .post<any>('/api/subscription/customer-link', reqparams)
      .subscribe(
        (res: any) => {
          responseInterface.getResult(res);
        },
        (err) => {
          responseInterface.getError(err);
        }
      );
  }

  getAzureSASLink(reqparams, responseInterface: ResponseInterface<any>) {
    return this.http.post<any>('/api/azure/sas', reqparams).subscribe(
      (res: any) => {
        responseInterface.getResult(res);
      },
      (err) => {
        responseInterface.getError(err);
      }
    );
  }

  didNotMakePayment(responseInterface: ResponseInterface<any>) {
    return this.http
      .post('/api/subscription-plan/did-not-make-payment', {})
      .subscribe(
        (res: any) => {
          responseInterface.getResult(res);
        },
        (err) => {
          responseInterface.getError(err);
        }
      );
  }

  createCourtesySubscription(responseInterface: ResponseInterface<any>) {
    return this.http
      .post<any>('/api/create-courtesy-subscription', {})
      .subscribe(
        (res: any) => {
          responseInterface.getResult(res);
        },
        (err) => {
          responseInterface.getError(err);
        }
      );
  }

  getPaymentCheckoutStatus(params, responseInterface: ResponseInterface<any>) {
    return this.http.post<any>('/api/get-checkout-status', params).subscribe(
      (res: any) => {
        responseInterface.getResult(res);
      },
      (err) => {
        responseInterface.getError(err);
      }
    );
  }

  getCardsMinimumData(
    reqparams,
    userId,
    responseInterface: ResponseInterface<any>
  ) {
    const route =
      this.userService.user.usertype === UserType.ADMIN
        ? `/api/admin/all-cards-minimum-data/${userId}`
        : '/api/all-cards-minimum-data';

    return this.http.post<any>(route, reqparams).subscribe(
      (res: any) => {
        responseInterface.getResult(res);
      },
      (err) => {
        responseInterface.getError(err);
      }
    );
  }

  addPaymentEnquery(params, responseInterface: ResponseInterface<any>) {
    return this.http.post('/api/add-payment-enquery', params).subscribe(
      (res: any) => {
        responseInterface.getResult(res);
      },
      (err) => {
        responseInterface.getError(err);
      }
    );
  }

  getRetirementAccounts(reqparams, responseInterface: ResponseInterface<any>) {
    return this.http
      .post<any>('/api/retirement-account/search', reqparams)
      .subscribe(
        (res: any) => {
          responseInterface.getResult(res);
        },
        (err) => {
          responseInterface.getError(err);
        }
      );
  }
  addRetirementAccount(reqparams, responseInterface: ResponseInterface<any>) {
    return this.http
      .post<any>('/api/retirement-account/add', reqparams)
      .subscribe(
        (res: any) => {
          responseInterface.getResult(res);
        },
        (err) => {
          responseInterface.getError(err);
        }
      );
  }
  editRetirementAccount(reqparams, responseInterface: ResponseInterface<any>) {
    return this.http
      .post<any>('/api/retirement-account/edit', reqparams)
      .subscribe(
        (res: any) => {
          responseInterface.getResult(res);
        },
        (err) => {
          responseInterface.getError(err);
        }
      );
  }
  deleteRetirementAccount(
    reqparams,
    responseInterface: ResponseInterface<any>
  ) {
    return this.http
      .post<any>('/api/retirement-account/delete', reqparams)
      .subscribe(
        (res: any) => {
          responseInterface.getResult(res);
        },
        (err) => {
          responseInterface.getError(err);
        }
      );
  }

  getCopiesOfIdentification(responseInterface: ResponseInterface<any>) {
    return this.http.get<any>('/api/identification/search').subscribe(
      (res: any) => {
        responseInterface.getResult(res);
      },
      (err) => {
        responseInterface.getError(err);
      }
    );
  }
  addIdentification(reqParams, responseInterface: ResponseInterface<any>) {
    return this.http.post<any>('/api/identification/add', reqParams).subscribe(
      (res: any) => {
        responseInterface.getResult(res);
      },
      (err) => {
        responseInterface.getError(err);
      }
    );
  }
  editIdentification(reqParams, responseInterface: ResponseInterface<any>) {
    return this.http.put<any>('/api/identification/edit', reqParams).subscribe(
      (res: any) => {
        responseInterface.getResult(res);
      },
      (err) => {
        responseInterface.getError(err);
      }
    );
  }
  deleteIdentification(reqParams, responseInterface: ResponseInterface<any>) {
    return this.http
      .delete<any>('/api/identification/delete', { body: reqParams })
      .subscribe(
        (res: any) => {
          responseInterface.getResult(res);
        },
        (err) => {
          responseInterface.getError(err);
        }
      );
  }

  syncDashboardData() {
    const self = this;
    if (self.userService.user.usertype === UserType.CONTACT) {
      return;
    }

    this.http.post<any>('/api/all-cards-data', {}).subscribe(
      (res: any) => {
        self.banks = res.data.banks;
        self.realEstates = res.data.realEstates;
        self.loginAccounts = res.data.loginAccounts;
        self.trusts = res.data.trusts;
        self.privateInvestments = res.data.privateInvestments;
        self.insurances = res.data.insurances;
        self.multimedias = res.data.multimedias;
        self.additionalDocs = res.data.additionalDocs;
        self.wills = res.data.wills;
        self.legalFinancialContacts = res.data.legalFinancialContacts;
        self.retirementAccounts = res.data.retirementAccounts;
        self.taxAccountants = res.data.taxAccountants;
        self.taxReturn = res.data.taxReturn;
        self.taxBasis = res.data.taxBasis;
        self.identification = res.data.identification;
        self.taxDocumentation = res.data.taxDocumentation;
        self.syncDataAction.next(true);
      },
      (err) => {
        console.log(err);
      }
    );
  }

  UploadChunkToAzureFunc(reqparams): Promise<any> {
    return this.http
      .post<any>(`/fileUploadAzureFunction/api/auth-jwt`, reqparams)
      .toPromise();
  }

  getDownloadStatus(reqParams: any, responseInterface: ResponseInterface<any>) {
    return this.http
      .get('/api/download', {
        params: reqParams,
        observe: 'response',
        responseType: 'text',
      })
      .subscribe(
        (res: any) => {
          responseInterface.getResult(res);
        },
        (err: any) => {
          responseInterface.getError(err);
        }
      );
  }
}
